import {
  CLEAN_CREATE_INCODE_LINKS,
  CLEAN_CREATE_INCODE_LINKS_ERROR,
  CREATE_INCODE_LINKS,
  CREATE_INCODE_LINKS_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function createIncodeLinksReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_INCODE_LINKS:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case CREATE_INCODE_LINKS_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_CREATE_INCODE_LINKS:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_CREATE_INCODE_LINKS_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
